// extracted by mini-css-extract-plugin
module.exports = {"errorWrapper":"ErrorFallback_errorWrapper__yI0M0","icon":"ErrorFallback_icon__vH58_","text":"ErrorFallback_text__Y6TXy"};